var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2H3V11H12V2Z",
    fill: "#F25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H3V21H12V12Z",
    fill: "#00A4EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H13V11H22V2Z",
    fill: "#7FBA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12H13V21H22V12Z",
    fill: "#FFB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/microsoft_icon.0858d5b3b6e78ebf074cc5b64b0e27ae.svg";
export { ForwardRef as ReactComponent };